module.exports = __webpack_public_path__ + "img/05.a196edda.jpg";